/* eslint-disable */
const olx = `<problem>
  <numericalresponse>
    <responseparam type="tolerance" default="5"/>
    <formulaequationinput/>
  </numericalresponse>
</problem>`

const markdown = `= 100 +-5`

export default { olx, markdown };
